import {MyAccountDashboardItemBase} from "../my-account-dashboard-item-base";
import React from "react";
import { PaperSheetIcon } from "../../../assets/svg/paper-sheet.icon";

export class MyDocumentsDashboardItem extends MyAccountDashboardItemBase {
    get text(): string {
        return this.services.language.translate('My Documents');
    }

    renderIcon(): React.ReactElement {
        return <PaperSheetIcon/>;
    }

    protected async _onExecute(): Promise<void> {
        this.services.navigator.routes.user.travelDocuments.activate();
    }
}
